import * as types from "../constants";

const initialState = {
  isLoading: true,
  error: null,
  items: [],
};

export default function notificationsMarkAsDoneReducer(
  state = initialState,
  action
) {
  switch (action.type) {
    case types.GET_NOTIFICATIONS_MARK_AS_DONE_INIT:
      return { ...state, error: null, isLoading: true };

    case types.GET_NOTIFICATIONS_MARK_AS_DONE_SUCCESS:
      return { ...state, isLoading: false, items: action.data.data };

    case types.GET_NOTIFICATIONS_MARK_AS_DONE_FAILURE:
      return {
        ...state,
        isLoading: false,
        error: action.notification.system_message,
      };

    default:
      return state;
  }
}
